/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            const handle = button.dataset.collection;

            this.buttons.forEach((el) => {
              el.classList.remove('active');
            });
            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.buttons.indexOf(event.target);
          if (index > -1 && this.buttons[index]) {
            this.buttons[index].dispatchEvent(new Event('click'));
          }
        });
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;

      const flkty = Flickity.data(slider);
      if (!flkty) return;

      const items = Array.from(slider.querySelectorAll('.columns[data-collection]'));
      const active = [];
      const inactive = [];

      items.forEach((el) => {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
          active.push(el);
        } else {
          el.classList.remove('carousel__slide');
          inactive.push(el);
        }
      });

      // Keep inactive cards outside Flickity slider
      inactive.forEach((el) => {
        slider.appendChild(el);
      });

      // Put active cards into Flickity slider in order (avoid insert() accumulation)
      active.forEach((el) => {
        flkty.slider.appendChild(el);
      });

      flkty.reloadCells();

      // Sync page dots with the new slide count after tab switch
      if (flkty.pageDots) {
        flkty.pageDots.setDots();
        flkty.pageDots.updateSelected();
      }

      flkty.resize();
      flkty.select(0, false, true);
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
